import { gql, useMutation } from '@apollo/client';

type SpecialOrderItemsArgs = {
  productId: number;
  price: number;
  quantity: number;
};

const CREATE_ORDER = gql`
  mutation CreateCompanySpecialOrder(
    $weekDate: DateTime!
    $comments: String!
    $day: Int!
    $items: [SpecialOrderItemsArgs!]!
  ) {
    createCompanySpecialOrder(
      createCompanySpecialOrderArgs: {
        weekDate: $weekDate
        comments: $comments
        day: $day
        specialOrderItems: $items
      }
    ) {
      message
      status
      statusCode
      error
      data {
        specialOrderId
      }
    }
  }
`;

export const useCreateSpecialOrder = () => {
  const [createSpecialOrderQuery, { error, data, loading }] =
    useMutation(CREATE_ORDER);

  const createSpecialOrder = (
    weekDate: string,
    day: number,
    comments: string,
    items: any[],
    onCompleteCb?: (data: any) => any,
  ) => {
    createSpecialOrderQuery({
      variables: {
        weekDate,
        day,
        items,
        comments,
      },
      onCompleted: onCompleteCb,
    });
  };

  return { createSpecialOrder, error, data, createOrderLoading: loading };
};
